import { StandaloneLink } from '~/ComponentsTW/wm';
import uploadDigitalDevicesExample from '~/files/upload_digital_devices.csv';
import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/sites';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const UploadDigitalDevices = ({ siteId }) => {
    const dispatch = useDispatch();
    const uploading = useSelector(state => state.sites.uploadingDevices);
    const uploadDigitalDevices = (siteId, file) => dispatch(actions.uploadDigitalDevices(siteId, file));

    const formSchema = [
        {
            accept: 'text/csv\n',
            label: 'File\x2a',
            name: 'file',
            type: 'file',
            validate: [validators.required]
        }
    ];

    const onSubmit = values => {
        const data = serializeForm(values, formSchema);
        uploadDigitalDevices(siteId, data.file);
    };

    return (
        <FormViewer label="Upload Digital Devices File">
            <StandaloneLink download="upload_digital_devices.csv" href={uploadDigitalDevicesExample} text="Download example file"/>
            <br/>
            <br/>
            <Form
                buttonLabel="Upload"
                formSchema={formSchema}
                isSubmitting={uploading}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default UploadDigitalDevices;
